import ClasificacionTerceroService from 'src/modules/clasificacionTercero/clasificacionTerceroService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'CLASIFICACIONTERCERO_VIEW';

const clasificacionTerceroViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: clasificacionTerceroViewActions.FIND_STARTED,
      });

      const record = await ClasificacionTerceroService.find(id);

      dispatch({
        type: clasificacionTerceroViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: clasificacionTerceroViewActions.FIND_ERROR,
      });

      getHistory().push('/clasificacion-tercero');
    }
  },
};

export default clasificacionTerceroViewActions;
